<template>
  <div class="page-container">
    <van-nav-bar
      fixed
      left-arrow
      :title="detialInfo.shareTitle"
      :z-index="10"
      @click-left="onBack"></van-nav-bar>
    <div class="contain">
      <div class="detailContain">
        <div class="d-info-images">
          <van-list v-for="(imageUrl, index) in imgDetailUrls" :key="index">
            <img class="d-image" :src="imageUrl" alt="详情图片" fit="cover" />
          </van-list>
        </div>
      </div>
      <div class="bottom-bg">
        <van-button class="btn" type="danger" @click="onBuy"
          >立即认购</van-button
        >
      </div>
    </div>
    <!-- 第九部分 风险测评 -->
    <van-popup class="assess-dialog" v-model="assessShow">
      <h2 class="mt-0 fs-xxl ta-c">您还没有完成风险测评</h2>
      <div class="mb-20">
        根据相关法规，买入前先进行测评，以便了解自身的风险承受能力，做出理性投资决策
      </div>
      <div class="ta-c">
        <van-button class="btn-assess" plain @click="goAssess"
          >立即测评</van-button
        >
      </div>
    </van-popup>
    <!-- 风险测评是否强制显示重新测评 -->
    <van-popup class="assess-dialog" v-model="resetAssessShow">
      <h2 class="mt-0 fs-xxl ta-c">温馨提示</h2>
      <div class="mb-20">
        您好！您之前的风险测评已到期，需要重新进行风险测评，请前往测评！
      </div>
      <div class="ta-c">
        <van-button class="btn-assess" plain @click="goAssess"
          >立即测评</van-button
        >
      </div>
    </van-popup>
  </div>
</template>
  
  <script src="http://res.wx.qq.com/open/js/jweixin-1.6.0.js" />
  <script>
import { List, Popup, Dialog } from "vant"
import { mapGetters, mapActions, mapMutations } from "vuex"
import session from "@/utils/session"
import * as CustApi from "@/api/cust"
export default {
  name: "myexclusive-companydesc",
  components: {
    [List.name]: List,
    [Popup.name]: Popup,
    [Dialog.name]: Dialog
  },
  data() {
    return {
      detialInfo: {},
      imgDetailUrls: [],

      assessShow: false,
      resetAssessShow: false
    }
  },
  computed: {
    ...mapGetters(["channel", "os", "token", "userInfo"])
  },
  mounted() {
    this._showLoading()
    CustApi.sectionInfo(this.$route.query.sectionId)
      .then((data) => {
        this._dismissLoading()
        this.detialInfo = data
        if (data.detailImg) {
          this.imgDetailUrls = data.detailImg.split(",")
        }
      })
      .catch((e) => {
        this._dismissLoading()
        Toast(e.msg || e.message)
      })
  },
  created() {
    setTimeout(() => {
      wx.hideAllNonBaseMenuItem()
    }, 1000)
    this.getUserInfo()
      .then((data) => {
        if (!data) {
          Toast("服务器繁忙, 请稍后再试")
          return
        }
        this.setUserInfo(data)
        // this.onNormalLook()
      })
      .catch((e) => {
        this._dismissLoading()
        Toast(e.msg || e.message)
      })
  },
  destroyed() {
    wx.showAllNonBaseMenuItem()
  },
  methods: {
    ...mapActions(["getUserInfo"]),
    ...mapMutations(["setUserInfo"]),
    onBack() {
      this.$router.replace({
        path: "/home",
        query: { chanlCode: this.channel }
      })
    },
    onBuy() {
      if (this.onNormalLook()) {
        this.$router.replace({
          path: "/myexclusive",
          query: {
            sectionId: this.$route.query.sectionId
          }
        })
      }
    },
    //判断是否已经完成基本信息的操作
    onNormalLook() {
      /*
      if (this.userInfo.isAuthName) {
        this.resetAssessShow =
          this.userInfo.userLevel > 0 ? this.userInfo.forceAssess : false
        if (this.userInfo.userLevel < 1) {
          session.setJson("cq", {
            sectionId: this.$route.query.sectionId,
            target: "myexclusive-companydesc"
          })
          this.assessShow = this.resetAssessShow == true ? false : true
          return false
        }
        //检测绑卡
        if (!this.userInfo.isBindCard) {
          Dialog.alert({
            title: "温馨提示",
            message: "您还未绑卡，请先去绑卡？",
            confirmButtonText: "去绑卡",
            showCancelButton: true,
            theme: "round-button"
          })
            .then(() => {
              session.setJson("cq", {
                sectionId: this.$route.query.sectionId,
                target: "myexclusive-companydesc"
              })
              this.$router.push({ name: "bindcard" })
            })
            .catch(() => {})
          return false
        }
        return true
      } else {
        //未设置实名
        Dialog.alert({
          title: "温馨提示",
          message: "您还未实名，请先去实名认证？",
          confirmButtonText: "去实名",
          showCancelButton: true,
          theme: "round-button"
        })
          .then(() => {
            session.setJson("cq", {
              sectionId: this.$route.query.sectionId,
              target: "myexclusive-companydesc"
            })
            this.$router.push({ name: "realname" })
          })
          .catch(() => {})
        return false
      }*/
      if (!this.userInfo.isAuthName) {
        //未设置实名
        Dialog.alert({
          title: "温馨提示",
          message: "您还未实名，请先去实名认证？",
          confirmButtonText: "去实名",
          showCancelButton: true,
          theme: "round-button"
        })
          .then(() => {
            session.setJson("cq", {
              sectionId: this.$route.query.sectionId,
              target: "myexclusive-companydesc"
            })
            this.$router.push({ name: "realname" })
          })
          .catch(() => {})
        return false
      }
      return true
    },
    goAssess() {
      session.setJson("cq", {
        sectionId: this.$route.query.sectionId,
        target: "myexclusive-companydesc"
      })
      this.$router.push({ path: "/questions" })
    }
  }
}
</script>
  
  <style lang="less" scoped>
html,
body {
  line-height: 0;
}
.contain {
  .detailContain {
    margin-bottom: 44px;
    .d-info-images {
      width: 100vw;
      margin: 0;
      padding: 0;
      .d-image {
        width: 100%;
        padding: 0;
        margin: 0;
      }
    }
  }
  .bottom-bg {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    // align-items: center;
    height: 44px;
    .btn {
      border: none;
      border-radius: 0;
      width: 100%;
      height: 100%;
      background-color: rgb(222, 189, 141);
      color: white;
      font-size: 18px;
      letter-spacing: 1px;
    }
  }
}
.assess-dialog {
  padding: 0.8rem;
  width: 70vw;

  .btn-assess {
    width: 70%;
    color: @golden;
    font-size: @font-size-xxl;
    border-color: @golden;
    border-radius: 5px;
  }
}
</style>
  